import { render } from "./USBankRecognizeFamilyEmergency.vue?vue&type=template&id=27e66fec&scoped=true"
import script from "./USBankRecognizeFamilyEmergency.vue?vue&type=script&lang=js"
export * from "./USBankRecognizeFamilyEmergency.vue?vue&type=script&lang=js"

import "./USBankRecognizeFamilyEmergency.vue?vue&type=style&index=0&id=27e66fec&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e66fec"]])

export default __exports__